(function ($) {
    'use strict';

    checkControls();

   function checkControls() {
       
        if ($(".js-latest-news-items > a").first().hasClass('current')) {
            
                $('.prev').addClass('disabled');
        
            } else {
                setPrevLink();
                $('.prev').removeClass('disabled');
            }

        if ($(".js-latest-news-items > a").last().hasClass('current')) {

                $('.next').addClass('disabled');

            } else {
                setNextLink();
                $('.next').removeClass('disabled');
            }   
    }

    var $btnShowMore = $('.js-show-more');

    $btnShowMore.on('click', function(e) {
        e.preventDefault();

        var start = $(this).data('start-index');
        var range = $(this).data('range');
        var end = start + range;
        
        for(start; start < end; start++) {
            
            if($('a[data-index='+start+']').length == 1) {
                $('a[data-index='+start+']').removeClass('visuallyhidden');
            }
        }

        $(this).data('start-index', end);

        if ($(".js-latest-news-items > a.visuallyhidden").length == 0) {
            $(this).addClass('visuallyhidden');
        } else {
            $(this).removeClass('visuallyhidden');
        }

    });

    function setPrevLink() {
        var $current = $('a.current');
        var currentIndex = $current.data('index');
        var prevIndex = currentIndex - 1;
        if(prevIndex > 0) {
            var $prevItem = $('a[data-index='+prevIndex+']');
            if($prevItem.length > 0) {
                var prevLink = $prevItem.prop('href');
                $('a.prev').prop('href', prevLink); 
            }
        }
    }

    function setNextLink() {
        var $current = $('a.current');
        var currentIndex = $current.data('index');
        var nextIndex = currentIndex + 1;
        var $nextItem = $('a[data-index='+nextIndex+']');
        if($nextItem.length > 0) {
            var nextLink = $nextItem.prop('href');
            $('a.next').prop('href', nextLink); 
        }
    }

}(jQuery));